module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_05.1131d1a6.svg";